import React from 'react';
import CLose from '../../../assets/img/ic-close.svg';
import { Button, Modal } from 'react-bootstrap';

const InfoModal = ( { show, description, tags, handleClose } ) =>
{
	let listItems;

	if ( tags !== undefined )
	{
		listItems = tags.map( ( item, index ) =>
			<span key={index}>
							{item}
							</span>
		);
	}

	if ( description === undefined || description === ""  )
	{
		description = "بدون توضیحات"
	}

	return (
		<Modal
			show={show}
			onHide={handleClose}
			backdrop="static"
			keyboard={false}
			id="infoModal"
			dialogClassName="info modal-dialog-centered m-auto">
			<Modal.Header>
				<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={handleClose}>
					<img aria-hidden="true" src={CLose} alt=""/>
				</button>
				<Modal.Title className="modal-title" id="infoModalLabel">اطلاعات</Modal.Title>
			</Modal.Header>
			<Modal.Body className="info">
				<p>
					توضیحات:
					<small className="mr-1">
					{description}
					</small>
				</p>
				<p>
					تگ‌ها:

					{
						listItems
					}
				</p>
			</Modal.Body>
			<Modal.Footer className="info justify-content-center">
				<Button onClick={handleClose}>
					بستن
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default InfoModal;
